module.exports = __webpack_public_path__ + "static/media/chhala.aa0cf33b.ogg";